import { TrashCanIcon } from '@icons';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import BottomSheet from './BottomSheet';
import Button from './Button';

export default function DeleteConfirmationBottomSheet({
  isOpen,
  onClose,
  deleteConfirmationHeader,
  deleteConfirmationText,
  onDeleteSucceeded = () => {},
  onDeleteFailed = (error: any) => {},
  deleteFunction
}: {
  isOpen: boolean;
  onClose: () => void;
  deleteConfirmationHeader: string;
  deleteConfirmationText: string;
  onDeleteSucceeded?: () => void;
  onDeleteFailed?: (error: any) => void;
  deleteFunction: () => Promise<void>;
}) {
  const { t } = useTranslation();
  const onDeleteCanceled = () => {
    onClose();
  };
  const onDeleteConfirmed = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await deleteFunction();
      onDeleteSucceeded();
    } catch (error) {
      onDeleteFailed(error);
    } finally {
      onClose();
    }
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} desktopVersion='modal'>
      <div className='flex flex-col items-center gap-md py-lg px-md dk:w-[400px] mx-auto'>
        <div className={classNames(setupForDark('text-primary'))}>
          <TrashCanIcon size={36} />
        </div>
        <div className={classNames('H5 text-center', setupForDark('text-primary'))}>
          {deleteConfirmationHeader}
        </div>
        <div className={classNames('P2R text-center', setupForDark('text-secondary'))}>
          {deleteConfirmationText}
        </div>
        <div className={classNames('flex flex-row mx-auto gap-sm w-full')}>
          <Button onClick={onDeleteConfirmed} type='tertiary' size='large' fullWidth>
            {t('components.deleteConfirmationBottomSheet.confirmationButton')}
          </Button>
          <Button onClick={onDeleteCanceled} type='primary' size='large' fullWidth>
            {t('components.deleteConfirmationBottomSheet.cancelButton')}
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
}
